import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { DatePipe } from '@angular/common'
import { ScoresService } from 'src/app/service/scores.service';
@Component({
  selector: 'app-ass-unit-update',
  templateUrl: './ass-unit-update.component.html',
  styleUrls: ['./ass-unit-update.component.scss']
})
export class AssUnitUpdateComponent implements OnInit {
  showLoader: boolean = false;
  updating: boolean = false;
  unitId: any;

  assessmentUnitUpdate = new FormGroup({
    nameAr: new FormControl('', [
      Validators.required,
    ]),
    nameEn: new FormControl('', [
      Validators.required,
    ]),
    active: new FormControl(0, [
      Validators.required,
    ]),
  });

  constructor(
    // private userService: UserService,
    private scoresService: ScoresService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private roleService: RoleService
    , private orgService: OrgService
    , private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.unitId = params['unitId'] || "";

        if (this.unitId != "") {
          this.getRankingById();
          this.showLoader = false;

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/scores-grades/assessment-units']);
        }
      });

  }

  getRankingById() {

  

     this.scoresService.getAssesmentUnitBYId(this.unitId).subscribe(
       data => {
         console.log(data);
       // this.CurrentCourseData = data;
        this.assessmentUnitUpdate.controls.nameAr.setValue(data.asesUnitNameAr);
        this.assessmentUnitUpdate.controls.nameEn.setValue(data.asesUnitNameEn);
        this.assessmentUnitUpdate.controls.active.setValue(data.active);
        // this.getAllCourses();
      },
      error => {
        this.updating = false;
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );

  }

  assessmentUnitUpdateChange() {
    // let classHours = this.createType.controls.classHours.value;
    // let clinicalHours = this.createType.controls.clinicalHours.value;
    // this.createType.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  assessmentUnitUpdateSubmit() {
    if (this.assessmentUnitUpdate.valid) {
      console.log(this.assessmentUnitUpdate.value);
      // call your service 
       let nameAr = this.assessmentUnitUpdate.controls.nameAr.value;
       let nameEn = this.assessmentUnitUpdate.controls.nameEn.value;
       let active=this.assessmentUnitUpdate.controls.active.value;
       this.addScoreRank(nameAr, nameEn,  active)
    }
    else {
      this.assessmentUnitUpdate.markAllAsTouched();
      this.assessmentUnitUpdate.markAsDirty();
    }
  }

  addScoreRank(nameAr: string, nameEn: string, active: any) {
     this.updating = true;
     let username = this.globals.currentUserInfo.username;
     this.scoresService.updateAssesmentUnit(username,this.unitId, 10, nameAr, nameEn, active)
       .subscribe(
         data => {
           console.log(data);
           if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
             this.updating = false;
             this.router.navigate(['/scores-grades/assessment-units']);
           } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
            this.updating = false;
            //this.router.navigate(['/academics/calender-day-type']);
          } 
         },
         error => {
           this.updating = false;
           this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
         }
       );
  }




  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() {

  }

}



